import React from "react";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select.tsx";
import { Theme, useTheme } from "@/lib/ThemeProvider.tsx";

const LooksSettings: React.FC = (props) => {
	const theme = useTheme();

	const handleChange = (value: Theme) => {
		theme.setTheme(value);
	};

	return (
		<div className={"w-full"}>
			<div className={"flex flex-col  p-4  w-full border-b"}>
				<div className={"flex justify-between items-center w-full"}>
					<h2>Mode</h2>

					<Select onValueChange={handleChange}>
						<SelectTrigger className="w-[180px]">
							<SelectValue placeholder="Theme" />
						</SelectTrigger>
						<SelectContent>
							<SelectItem value="light">Light</SelectItem>
							<SelectItem value="dark">Dark</SelectItem>
							<SelectItem value="system">
								System
							</SelectItem>
						</SelectContent>
					</Select>
				</div>
			</div>
		</div>
	);
};

export { LooksSettings };
